import React, { useEffect, useState } from "react";
import useEmployeeHook from "../../../hooks/useEmployeeHook";
import NavigatebackBtn from "../../../components/generic/NavigateBackBtn";
import { useNavigate } from "react-router-dom";
import { onGetEmployeeByID } from "../../../services/employee";
import { useStateGetter } from "../../../hooks/statehooks/UseStateGettersHook";
import { toast } from "react-toastify";
import { useStateSetter } from "../../../hooks/statehooks/UseStateSettersHook";
import { LuUser } from "react-icons/lu";
import { CiCamera } from "react-icons/ci";
import { HiOutlinePhone } from "react-icons/hi2";
import { SlCalender } from "react-icons/sl";
import { LuMail } from "react-icons/lu";
import ContactInfo from "./ContactInfo";
import CRMContacts from "./CRMContacts";

export default ({ id }: any) => {
  const [showadddept, setshowadddept] = useState(false);
  const { SelectedOrg, config } = useStateGetter();
  const [emplyeedetails, setemplyeedetails] = useState<any>({});
  const { setLoading, setSidebarRenderView } = useStateSetter();
  const navigate = useNavigate();

  const tabs = [
    "Contact info",
    "Pipeline",
    "Sales and purchase",
    "Accounting",
    "Activity",
  ];
  const tabViews = [
    <ContactInfo />,
    <>Pipeline</>,
    <>Sales and purchase</>,
    <>Accounting</>,
    <>Activity</>,
  ];

  const [selectedTab, setselectedTab] = useState(tabs[0]);
  const { authuser } = useStateGetter();
  const [selectedTabview, setselectedTabview] = useState(tabViews[0]);
  const ProfilePic = () => (
    <div className="flex flex-col justify-center items-center  ">
      <LuUser
        className="  p-4 rounded-full bg-faintBlue  text-textbg"
        size={120}
      />
      <div className="px-3 bg-faintBlue mt-2 rounded">
        <CiCamera className="inline text-textbg" />
        <p className="inline text-sm font-semibold ml-2  text-textbg">
          Upload Photo
        </p>
      </div>
    </div>
  );
  const ActionItem2 = ({ title }: any) => (
    <div
      onClick={() => {
        setselectedTabview(tabViews[tabs.indexOf(title)]);
        setselectedTab(title);
      }}
      className={` m-1 rounded-[8px]  text-sm  p-2  font-semibold ${
        selectedTab == title
          ? "bg-blueGray text-white"
          : " bg-faintBlue text-textbg "
      }`}
    >
      <p className="  cursor-pointer text-xs">{title}</p>
    </div>
  );

  const ActionItem1 = ({ icon, title }: any) => (
    <div className="px-6 py-1 my-1 font-semibold border opacity-50 border-gray-400  rounded-[10px] flex justify-center items-center text-sm">
      {icon} {title}{" "}
    </div>
  );

  const getEmployeeById = async () => {
    setLoading(true);
    try {
      var res = await onGetEmployeeByID(id, config);
      setemplyeedetails(res.data);
      setLoading(false);
    } catch (e: any) {
      toast.error(e);
      console.log(e);
      setLoading(false);
    }
  };

  useEffect(() => {
    getEmployeeById();
  }, []);

  return (
    <div className="w-full   flex min-h-screen  ">
      <div
        className={` p-6 bg-white    overflow-y-scroll overflow-x-hidden  w-full h-full rounded-[20px]  `}
      >
        <div className="  w-full  flex justify-between items-center  ">
          <div className="inline">
            <NavigatebackBtn
              style={"!inline mr-2  mb-2"}
              onclick={() => {
                setSidebarRenderView(<CRMContacts />);
              }}
            />
            <p className="text-textbg font-medium !inline text-sm mb-2 text-[16px] bg-white">
              {emplyeedetails.firstName} {emplyeedetails.lastName}
            </p>
          </div>
        </div>
        <hr className="my-2" />
        <div className="flex justify-between ">
          <div className="flex justify-center items-center">
            <ProfilePic />
            <div className="flex flex-col">
              <p className="font-bold text-textbg text-lg">
                {emplyeedetails.firstName} {emplyeedetails.lastName}
              </p>
              <p className="font-light">{emplyeedetails.jobTitle}</p>
            </div>
          </div>

          {!authuser.isEmployee && (
            <div className="flex flex-col opacity-55">
              <ActionItem1
                title={"Call"}
                icon={<HiOutlinePhone className=" mr-1 inline" />}
              />
              <ActionItem1
                title={"Schedule Meeting"}
                icon={<SlCalender className=" mr-1 inline" />}
              />
              <ActionItem1
                title={"Send Email"}
                icon={<LuMail className=" mr-1 inline" />}
              />
            </div>
          )}
        </div>
        <hr className="my-2" />
        <div className="flex mb-4">
          {tabs.map((i) => (
            <ActionItem2 title={i} />
          ))}
        </div>

        {selectedTabview}
      </div>
    </div>
  );
};
